module.exports = __webpack_public_path__ + "img/dne.ef18d1b8.svg";